import { render, staticRenderFns } from "./FeeItem.vue?vue&type=template&id=4da68401&scoped=true&"
import script from "./FeeItem.vue?vue&type=script&lang=js&"
export * from "./FeeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da68401",
  null
  
)

export default component.exports